import generateUUID from "syf-js-utilities/helpers/generateUUID";
import { getProfileCorrelationId, setProfileCorrelationId, } from "./profileSessionStorage";
var getCorrelationId = function () {
    var correlationId = getProfileCorrelationId();
    if (!correlationId) {
        correlationId = generateUUID();
        setProfileCorrelationId(correlationId);
    }
    return correlationId;
};
export default getCorrelationId;
